import { ReactKeycloakProvider } from "@react-keycloak/web";
import React from "react";
import { createRoot } from "react-dom/client";
import { Provider } from "react-redux";
// Router will be handled in App component
import { App } from "./App";
import MainTheme from "./App/MainTheme";
import * as serviceWorker from "./serviceWorker";
import { createReduxStore } from "./store/ReduxStore";
import { BaseProvider } from "@vwpfs/mary-air-lib/components/air/03-base/Base";
import { Themes } from "@vwpfs/mary-air-lib/theme/_Types";
import { ensure } from "@vwpfs/mary-air-lib/utils/Optional";
import { ErrorBoundary } from "@vwpfs/mary-air-lib/utils/Boundary";
import keycloak from "./keycloak";
import { I18nLanguage} from "@vwpfs/mary-air-lib/utils/translations/index";

//
const elm = document.getElementById("root");

if (!elm) {
    throw new Error("Root element not found");
}

/**
 *
 */
enum ConfigProps {
    API_ENDPOINT = "data-api-endpoint",
}

const store = createReduxStore({
    apiEndpoint: ensure(elm.getAttribute(ConfigProps.API_ENDPOINT) || undefined),
});

/**
 *
 */
const Root: React.FunctionComponent<{}> = () => (
    <ReactKeycloakProvider
        authClient={keycloak}
        initOptions={{ onLoad: "login-required", checkLoginIframe: false }}
    >
        <BaseProvider
            theme={Themes.VWPFS}
            language={I18nLanguage.ENGLISH}
        >
            <ErrorBoundary>
                <Provider store={store}>
                    <MainTheme>
                        <App />
                    </MainTheme>
                </Provider>
            </ErrorBoundary>
        </BaseProvider>
    </ReactKeycloakProvider>
);

const root = createRoot(elm);
root.render(<Root />);
serviceWorker.unregister();
